module.exports = __webpack_public_path__ + "img/paas_wrapbg1.f35bfdea.png";